<template>
  <div class="boxed-countdown-wrapper" :style="countdownStyle">
    <div v-if="countdownSettings.showDays" class="countdown-block">
      <div class="countdown-box">{{ displayDays }}</div>
      <div class="countdown-label">Days</div>
    </div>
    <div v-if="countdownSettings.showDays && countdownSettings.showHours" class="separator">:</div>
    <div v-if="countdownSettings.showHours" class="countdown-block">
      <div class="countdown-box">{{ displayHours }}</div>
      <div class="countdown-label">Hours</div>
    </div>
    <div v-if="countdownSettings.showHours && countdownSettings.showMinutes" class="separator">:</div>
    <div v-if="countdownSettings.showMinutes" class="countdown-block">
      <div class="countdown-box">{{ displayMinutes }}</div>
      <div class="countdown-label">Minutes</div>
    </div>
    <div v-if="countdownSettings.showMinutes && countdownSettings.showSeconds" class="separator">:</div>
    <div v-if="countdownSettings.showSeconds" class="countdown-block">
      <div class="countdown-box">{{ displaySeconds }}</div>
      <div class="countdown-label">Seconds</div>
    </div>
  </div>
</template>

<script>
// This script is identical to the SimpleCountdown script.
// You could abstract this logic into a reusable Vue Composable (Vue 3)
// or a Mixin (Vue 2) if you plan on creating many similar components.
export default {
  name: 'BoxedCountdown',
  props: ['endDate', 'countdownSettings'],
  data() {
    return {
      displayDays: '00',
      displayHours: '00',
      displayMinutes: '00',
      displaySeconds: '00',
      timer: null
    };
  },
  computed: {
    countdownStyle() {
      return {
        '--text-color': this.countdownSettings.textColour || '#FFFFFF',
        '--background-color': this.countdownSettings.backgroundColour || '#333333'
      };
    },
    _seconds() { return 1000; },
    _minutes() { return this._seconds * 60; },
    _hours() { return this._minutes * 60; },
    _days() { return this._hours * 24; }
  },
  mounted() {
    this.showRemaining();
    this.timer = setInterval(this.showRemaining, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    formatNum(num) {
      return num < 10 ? '0' + num : num;
    },
    showRemaining() {
      const timer = new Date(this.endDate).getTime() - new Date().getTime();

      if (timer < 0) {
        clearInterval(this.timer);
        this.displayDays = '00';
        this.displayHours = '00';
        this.displayMinutes = '00';
        this.displaySeconds = '00';
        return;
      }

      const days = Math.floor(timer / this._days);
      const hours = Math.floor((timer % this._days) / this._hours);
      const minutes = Math.floor((timer % this._hours) / this._minutes);
      const seconds = Math.floor((timer % this._minutes) / this._seconds);

      this.displayDays = this.formatNum(days);
      this.displayHours = this.formatNum(hours);
      this.displayMinutes = this.formatNum(minutes);
      this.displaySeconds = this.formatNum(seconds);
    }
  }
}
</script>

<style scoped>
.boxed-countdown-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 30px 15px;
  border-radius: 10px;
  font-family: 'Helvetica Neue', sans-serif;
}

.countdown-block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.countdown-box {
  background-color: var(--background-color);
  color: var(--text-color);
  font-size: 3rem;
  font-weight: 500;
  line-height: 1;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  min-width: 80px; /* Ensure boxes have the same width */
}

.countdown-label {
  color: #888;
  font-size: 0.9rem;
  text-transform: uppercase;
  margin-top: 10px;
  letter-spacing: 1px;
}

.separator {
  font-size: 3rem;
  color: #888;
  margin: 0 10px;
  padding-bottom: 35px; /* Align with boxes */
}
</style>